const updates = [
  {
    date: '2026.07.30',
    title: '《星际迷航：新纪元》高清版已上线',
    desc: '年度科幻巨制正式登陆8848影院，支持4K超清画质和杜比音效，带来沉浸式星际探索体验。',
  },
  {
    date: '2026.07.27',
    title: '暑期喜剧专题「笑到停不下来」上线',
    desc: '精选20部豆瓣高分喜剧电影，涵盖国产、日韩和欧美佳作，陪你度过欢乐夏日时光。',
  },
  {
    date: '2026.07.23',
    title: '经典修复系列新增《霸王别姬》数字重制版',
    desc: '陈凯歌导演的华语电影巅峰之作以全新数字修复画质回归，重温那段动人至深的梨园传奇。',
  },
  {
    date: '2026.07.20',
    title: '动作片库扩容：新增50部港产动作经典',
    desc: '成龙、李连杰、甄子丹等功夫巨星的经典作品集中上线，功夫片迷的饕餮盛宴不容错过。',
  },
  {
    date: '2026.07.16',
    title: '播放体验升级：智能码率自适应功能上线',
    desc: '全新播放引擎自动匹配最佳画质，弱网环境下依然流畅观影，再也不用担心卡顿中断。',
  },
  {
    date: '2026.07.12',
    title: '纪录片专区「真实的力量」正式开放',
    desc: '涵盖自然、历史、人文、科技四大主题，汇集BBC、国家地理等顶级制作机构的精品纪录片。',
  },
  {
    date: '2026.07.08',
    title: '移动端观影体验全面优化',
    desc: '针对手机和平板设备进行了深度适配，手势控制、横竖屏切换和投屏功能更加便捷流畅。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full mb-4">
            最新快讯
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            片库更新、功能升级、专题策划，8848影院的每一次进步都在这里记录
          </p>
        </div>

        <div className="relative pl-8 md:pl-12">
          <div className="absolute left-3 md:left-4 top-0 bottom-0 w-px bg-gradient-to-b from-accent-500/40 via-background-300/40 to-transparent"></div>

          <div className="space-y-8 md:space-y-10">
            {updates.map((item, idx) => (
              <div key={idx} className="relative">
                <div className="absolute -left-[33px] md:-left-[43px] top-1 w-3 h-3 md:w-4 md:h-4 rounded-full bg-accent-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6">
                  <span className="text-xs font-medium text-accent-400 bg-accent-500/10 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                    {item.date}
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}